var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulseBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "building2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.50033 12.25C2.95784 12.25 2.6866 12.25 2.46406 12.1904C1.86015 12.0286 1.38844 11.5568 1.22662 10.953C1.16699 10.7304 1.16699 10.4592 1.16699 9.91667V7.58333C1.16699 7.04083 1.16699 6.76958 1.22662 6.54704C1.38844 5.94318 1.86015 5.47144 2.46406 5.30963C2.6866 5.25 2.95784 5.25 3.50033 5.25",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5 12.25C11.0425 12.25 11.3138 12.25 11.5363 12.1904C12.1402 12.0286 12.6119 11.5568 12.7737 10.953C12.8333 10.7304 12.8333 10.4592 12.8333 9.91667V7.58333C12.8333 7.04083 12.8333 6.76958 12.7737 6.54704C12.6119 5.94318 12.1402 5.47144 11.5363 5.30963C11.3138 5.25 11.0425 5.25 10.5 5.25",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5 12.25V5.25C10.5 3.60008 10.5 2.77513 9.98742 2.26256C9.47485 1.75 8.6499 1.75 7 1.75C5.35008 1.75 4.52513 1.75 4.01256 2.26256C3.5 2.77513 3.5 3.60008 3.5 5.25V12.25H10.5Z",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.83301 12.2497V10.4997C5.83301 9.94971 5.83301 9.67472 6.00387 9.50387C6.17472 9.33301 6.44971 9.33301 6.99967 9.33301C7.54964 9.33301 7.82462 9.33301 7.99548 9.50387C8.16634 9.67472 8.16634 9.94971 8.16634 10.4997V12.2497",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.83301 4.66699H8.16634",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.83301 7H8.16634",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseBuilding);
export default __webpack_public_path__ + "static/media/pulse-building.74fefc8476624a3c6c0be15cbdab9acd.svg";
export { ForwardRef as ReactComponent };